import { ALLOWED_QUERY_PARAMS } from '../../constants/enums';

const isUrl = exp => {
  const a = new RegExp(
    '^(https?:\\/\\/)?' +
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
      '((\\d{1,3}\\.){3}\\d{1,3}))' +
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
      '(\\?[;&a-z\\d%_.~+=-]*)?' +
      '(\\#[-a-z\\d_]*)?$',
    'i',
  );
  return !a.test(exp);
};

export default isUrl;

export const hasValidQueryParams = queryParams => {
  return Object.keys(queryParams).some(key => [ALLOWED_QUERY_PARAMS.INVITATION].includes(key));
};
